import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GroundworksAuthLifecycleService } from '@groundworks/ngx-groundworks-auth';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly lifecycle = inject(GroundworksAuthLifecycleService);

  ngOnInit(): void {
    this.lifecycle.start();
  }

  ngOnDestroy(): void {
    this.lifecycle.stop();
  }
}
